// Dashboard.jsx
import React from 'react';
import FileUploadSection from './FileUploadSection';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import VideoConnections from './VideoConnections';

const Dashboard = () => {
  const navigate = useNavigate();
  const handleUploadComplete = () => navigate('/jobs');

  return (
    <div className="dashboard-container">
      <div className="upload-card">
        <FileUploadSection 
          onUploadComplete={handleUploadComplete}
          apiUrl={process.env.REACT_APP_API_URL}
        />
      </div>
      <VideoConnections />
    </div>
  );
};

export default Dashboard;
